import datos from "../../src/data/geojson/json/generatedConfig.json";

// Estructura de árbol para Mercados Minoristas
export const mercadosTreeConfig = [
  {
    id: 1, // EJECUTADAS
    label: "EJECUTADAS",
    childrenField: "id_modalidad",
    children: [
      { id: 9, label: "PI-PNDP" },
      { id: 4, label: "IOARR-PNDP" },
      { id: 10, label: "Gob. Local" },
    ]
  },
  {
    id: 2, // EN EJECUCIÓN
    label: "EN EJECUCIÓN",
    childrenField: "id_modalidad",
    children: [
      { id: 9, label: "PI-PNDP" },
      { id: 4, label: "IOARR-PNDP" },
      { id: 16, label: "Gob. Local (Monitoreo)" },
    ]
  },
  {
    id: 4, // EXPEDIENTE TÉCNICO
    label: "EXPEDIENTE TÉCNICO",
    childrenField: "id_modalidad",
    children: [
      { id: 11, label: "Contrata PNDP" },
      { id: 12, label: "PI-PNDP" },
      { id: 4, label: "IOARR-PNDP" },
      { id: 13, label: "Gob. Local (Asis. Tec.)" },
    ]
  },
  {
    id: 6, // PREINVERSION
    label: "PREINVERSIÓN",
    childrenField: "id_modalidad",
    children: [
      { id: 12, label: "PI-PNDP" },
      { id: 4, label: "IOARR-PNDP" },
      { id: 13, label: "Gob. Local (Asis. Tec.)" },
    ]
  },
  {
    id: 7, // CONSULTAS TÉCNICAS
    label: "CONSULTAS TÉCNICAS",
    childrenField: "id_modalidad",
    children: [
      { id: 14, label: "Etapa expediente (GL)" },
      { id: 15, label: "Etapa preinversión (GL)" },
    ]
  },
];

export const filterConfig = {
  mercadosMinoristas: {

    // 1) OBRAS (TIPO_ESTADO_INTERVENCION)
    // Ubigeos
    "departamento": datos.zonasIndustriales.departamento,
    "provincia": datos.zonasIndustriales.provincia,
    "distrito": datos.zonasIndustriales.distrito,
    /*  modalidad: [
        { label: "PROYECTOS DE INVERSIÓN", clave: "id_modalidad", value: 1 },
        { label: "OBRAS POR IMPUESTOS", clave: "id_modalidad", value: 2 },
        { label: "PROYECTOS EN ACTIVOS", clave: "id_modalidad", value: 3 },
        { label: "IOARR", clave: "id_modalidad", value: 4 },
        { label: "ASISTENCIA TÉCNICA", clave: "id_modalidad", value: 5 },
        { label: "PROMOCIÓN Y GESTIÓN", clave: "id_modalidad", value: 6 },
        { label: "MONITOREO DE OBRA", value: 7 },
      ],
      etapa: [
        { label: "CONSULTA", clave: "id_etapa", value: 1 },
        { label: "PROCESO DE FIRMA DE CONVENIO", clave: "id_etapa", value: 2 },
        { label: "PRE INVERSIÓN", clave: "id_etapa", value: 3 },
        {
          label: "PROCESO DE SELECCIÓN PARA EXPEDIENTE",
          clave: "id_etapa",
          value: 4,
        },
        { label: "ELABORACIÓN DE EXPEDIENTE", clave: "id_etapa", value: 5 },
        {
          label: "BUENA PRO-PROCESO FIRMA CONTRATO",
          clave: "id_etapa",
          value: 6,
        },
        { label: "EJECUCIÓN FÍSiCA", clave: "id_etapa", value: 7 },
        { label: "LIQUIDACIÓN", clave: "id_etapa", value: 8 },
        { label: "CONCLUIDO", clave: "id_etapa", value: 9 },
        { label: "PROCESO OBRAS X IMPUESTO", clave: "id_etapa", value: 10 },
        {
          label: "ELABORACIÓN DE EXPEDIENTE DE SALDO DE OBRA",
          clave: "id_etapa",
          value: 11,
        },
        { label: "OBRA PARALIZADA", clave: "id_etapa", value: 12 },
        { label: "EXPEDIENTE TECNICO PARALIZADO", clave: "id_etapa", value: 13 },
        { label: "OPERACIÓN Y GESTIÓN", clave: "id_etapa", value: 14 },
      ],
      tipo_convenio: [
        {
          label: "CONVENIO PNDP-MUNICIP. DIST",
          clave: "id_tipo_convenio",
          value: 1,
        },
        {
          label: "CONVENIO PNDP-MUNICIP. PROV.",
          clave: "id_tipo_convenio",
          value: 2,
        },
        { label: "SIN CONVENIO", clave: "id_tipo_convenio", value: 3 },
        { label: "NO CORRESPONDE", clave: "id_tipo_convenio", value: 4 },
      ],
      financiamiento: [
        { label: "PNDP", clave: "id_financiamiento", value: 1 },
        {
          label: "TRANSFERENCIA A MUNICIPALIDAD",
          clave: "id_financiamiento",
          value: 2,
        },
        { label: "MUNICIPALIDAD", clave: "id_financiamiento", value: 3 },
        { label: "SIN FINANCIAMIENTO", clave: "id_financiamiento", value: 4 },
      ],*/
  },
  mercadosMayoristas: {
    // tipo: [
    //   { label: "MERCADOS DE ABASTOS MAYORISTAS", clave: "id_tipo", value: 1 },
    // ],
    modalidad: [
      { label: "PROYECTOS DE INVERSIÓN", clave: "id_modalidad", value: 1 },
      { label: "OBRAS POR IMPUESTOS", clave: "id_modalidad", value: 2 },
      { label: "PROYECTOS EN ACTIVOS", clave: "id_modalidad", value: 3 },
      { label: "IOARR", clave: "id_modalidad", value: 4 },
      { label: "ASISTENCIA TÉCNICA", clave: "id_modalidad", value: 5 },
      { label: "PROMOCIÓN Y GESTIÓN", clave: "id_modalidad", value: 6 },
      { label: "MONITOREO DE OBRA", clave: "id_modalidad", value: 7 },
    ],
    etapa: [
      { label: "CONSULTA", clave: "id_etapa", value: 1 },
      { label: "PROCESO DE FIRMA DE CONVENIO", clave: "id_etapa", value: 2 },
      { label: "PRE INVERSIÓN", clave: "id_etapa", value: 3 },
      { label: "PROCESO DE SELECCIÓN PARA EXPEDIENTE", clave: "id_etapa", value: 4, },
      { label: "ELABORACIÓN DE EXPEDIENTE", clave: "id_etapa", value: 5 },
      { label: "BUENA PRO-PROCESO FIRMA CONTRATO", clave: "id_etapa", value: 6, },
      { label: "EJECUCIÓN FÍSiCA", clave: "id_etapa", value: 7 },
      { label: "LIQUIDACIÓN", clave: "id_etapa", value: 8 },
      { label: "CONCLUIDO", clave: "id_etapa", value: 9 },
      { label: "PROCESO OBRAS X IMPUESTO", clave: "id_etapa", value: 10 },
      { label: "ELABORACIÓN DE EXPEDIENTE DE SALDO DE OBRA", clave: "id_etapa", value: 11, },
      { label: "OBRA PARALIZADA", clave: "id_etapa", value: 12 },
      { label: "EXPEDIENTE TECNICO PARALIZADO", clave: "id_etapa", value: 13 },
      { label: "OPERACIÓN Y GESTIÓN", clave: "id_etapa", value: 14 },
    ],
    tipo_convenio: [
      { label: "CONVENIO PNDP-MUNICIP. DIST", clave: "id_tipo_convenio", value: 1, },
      { label: "CONVENIO PNDP-MUNICIP. PROV.", clave: "id_tipo_convenio", value: 2, },
      { label: "SIN CONVENIO", clave: "id_tipo_convenio", value: 3 },
      { label: "NO CORRESPONDE", clave: "id_tipo_convenio", value: 4 },
    ],
    financiamiento: [
      { label: "PNDP", clave: "id_financiamiento", value: 1 },
      { label: "TRANSFERENCIA A MUNICIPALIDAD", clave: "id_financiamiento", value: 2, },
      { label: "MUNICIPALIDAD", clave: "id_financiamiento", value: 3 },
      { label: "SIN FINANCIAMIENTO", clave: "id_financiamiento", value: 4 },
    ],
  },
  parquesIndustriales: {
    // tipo: [{ label: "PARQUES INDUSTRIALES", clave: "id_tipo", value: 1 }],
    "departamento": datos.zonasIndustriales.departamento,
    "provincia": datos.zonasIndustriales.provincia,
    "distrito": datos.zonasIndustriales.distrito,
    // modalidad: [
    //   { label: "PROYECTOS DE INVERSIÓN", clave: "id_modalidad", value: 1 },
    //   { label: "OBRAS POR IMPUESTOS", clave: "id_modalidad", value: 2 },
    //   { label: "PROYECTOS EN ACTIVOS", clave: "id_modalidad", value: 3 },
    //   { label: "PROMOCIÓN Y GESTIÓN", clave: "id_modalidad", value: 4 },
    // ],
    // etapa: [
    //   { label: "CONSULTA", clave: "id_etapa", value: 1 },
    //   { label: "PROCESO DE FIRMA DE CONVENIO", clave: "id_etapa", value: 2 },
    //   { label: "ASISTENCIA TECNICA", clave: "id_etapa", value: 3 },
    //   { label: "ELABORACIÓN DE ESTUDIO DE DEMANDA",clave: "id_etapa",value: 4,},
    //   { label: "ELABORACIÓN DE PLAN MAESTRO", clave: "id_etapa", value: 5 },
    //   { label: "ELABORACIÓN DE ESTUDIOS BÁSICOS", clave: "id_etapa", value: 6 },
    //   { label: "TRANSACCIÓN", clave: "id_etapa", value: 7 },
    //   { label: "BUENA PRO-PROCESO FIRMA CONTRATO",clave: "id_etapa",value: 8,},
    //   { label: "EJECUCIÓN CONTRACTUAL", clave: "id_etapa", value: 9 },
    //   { label: "ELABORACIÓN DE EXPEDIENTE DE SALDO DE OBRA",clave: "id_etapa",value: 10,},
    //   { label: "OBRA PARALIZADA", clave: "id_etapa", value: 11 },
    //   { label: "OPERACIÓN Y GESTIÓN", clave: "id_etapa", value: 12 },
    // ],
    tipo_convenio: [
      { label: "CONVENIO PNDP - GORE/MUNI", clave: "tipo_convenio", value: 1 },
      /* { label: "CONVENIO PNDP-EMP. PRIVADA", clave: "tipo_convenio", value: 2, },
       { label: "SIN CONVENIO", clave: "tipo_convenio", value: 3 },
       { label: "EN EVALUACIÓN", clave: "tipo_convenio", value: 4 },
       { label: "EN TRÁMITE", clave: "tipo_convenio", value: 5 },
       { label: "NO CORRESPONDE", clave: "tipo_convenio", value: 6 },*/
    ],
    // sector: [
    //   { label: "GOBIERNO NACIONAL", clave: "id_sector", value: 1 },
    //   { label: "GOBIERNO REGIONAL", clave: "id_sector", value: 2 },
    //   { label: "GOBIERNO LOCAL", clave: "id_sector", value: 3 },
    //   { label: "EMPRESA PRIVADA", clave: "id_sector", value: 4 },
    // ],
    disponibilidad: [
      { label: "DISPONIBLE", clave: "id_ocupacion", value: 1 },
      { label: "NO DISPONIBLE", clave: "id_ocupacion", value: 2, },
    ],
    uso: [
      { label: "SERVICIOS COMUNES", clave: "idUso", value: 17 },
      { label: "COMERCIAL", clave: "idUso", value: 18 },
      { label: "SERVICIOS BÁSICOS", clave: "idUso", value: 19 },
      { label: "APORTES", clave: "idUso", value: 20 },
      { label: "RECREACIÓN", clave: "idUso", value: 21 },
      { label: "RESIDENCIAL", clave: "idUso", value: 22 },
      { label: "INDUSTRIAL", clave: "idUso", value: 23 },
    ],
  },
  zonasIndustriales: {
    // tipo: [{ label: "ZONAS INDUSTRIALES", clave: "id_tipo", value: 2 }],
    "departamento": datos.zonasIndustriales.departamento,
    "provincia": datos.zonasIndustriales.provincia,
    "distrito": datos.zonasIndustriales.distrito,
    zona: [
      { label: "ZONA 1 LAS VEGAS", clave: "id_zona", value: 2 },
    ],
    zonificacion: [
      { label: "I1", clave: "id_zonificacion", value: 1 },
      { label: "I2", clave: "id_zonificacion", value: 2 },
      { label: "I3", clave: "id_zonificacion", value: 3 },
      { label: "I4", clave: "id_zonificacion", value: 4 },
    ],
    uso: [
      { label: "COMERCIAL", clave: "id_uso", value: 1 },
      { label: "EDUCATIVO", clave: "id_uso", value: 2 },
      { label: "INDUSTRIAL", clave: "id_uso", value: 3 },
      { label: "RESIDENCIAL", clave: "id_uso", value: 4 },
      { label: "SERVICIOS PUBLICOS Y ADMINISTRATIVOS", clave: "id_uso", value: 5 },
      { label: "SALUD", clave: "id_uso", value: 6 },
      { label: "INSTITUCIONAL", clave: "id_uso", value: 7 },
      { label: "RECREATIVO", clave: "id_uso", value: 8 },
      { label: "AGRICOLA Y FORESTAL", clave: "id_uso", value: 9 },
      { label: "TURISTICO Y CULTURAL", clave: "id_uso", value: 10 },
      { label: "VIVIENDA TALLER", clave: "id_uso", value: 11 },
      { label: "SE DESCONOCE", clave: "id_uso", value: 12 },
    ],
    // estado_lote: [
    //   { label: "CON EDIFICACIÓN", clave: "id_edificacion", value: 1 },
    //   { label: "SIN EDIFICACIÓN", clave: "id_edificacion", value: 2 },
    // ],
    // tipo_construccion: [
    //   { label: "ALMACEN", clave: "id_construccion", value: 1 },
    //   { label: "EDIFICACION DE OFICINA", clave: "id_construccion", value: 2,},
    //   { label: "FABRICA", clave: "id_construccion", value: 3 },
    //   { label: "GASOLINERA", clave: "id_construccion", value: 4 },
    //   { label: "LOCAL COMERCIAL", clave: "id_construccion", value: 5 },
    //   { label: "OTRO", clave: "id_construccion", value: 6 },
    //   { label: "TALLER", clave: "id_construccion", value: 7 },
    //   { label: "TERRENO", clave: "id_construccion", value: 8 },
    // ],
    // identificacion: [
    //   { label: "EMPRESA IDENTIFICADA", clave: "id_estado_identificacion", value: 1 },
    //   { label: "EMPRESA NO IDENTIFICADA",clave: "id_estado_identificacion",value: 2,},
    // ],
    ocupacion: [
      { label: "OCUPADO", clave: "id_ocupacion", value: 1 },
      { label: "NO OCUPADO", clave: "id_ocupacion", value: 2, },
    ],
    // ruc: [
    //   { label: "Sí", clave: "ruc", value: 'si' },
    //   { label: "No", clave: "ruc", value: "no" },
    // ],
    // rubro: [
    //   { label: "ALIMENTOS", clave: "id_rubro", value: 1 },
    //   { label: "AUTOMOTRIZ", clave: "id_rubro", value: 2 },
    //   { label: "CONSTRUCCION", clave: "id_rubro", value: 3 },
    //   { label: "LOGISTICA", clave: "id_rubro", value: 4 },
    //   { label: "MADERERA", clave: "id_rubro", value: 5 },
    //   { label: "METAL MECANICA", clave: "id_rubro", value: 6 },
    //   { label: "METALES", clave: "id_rubro", value: 7 },
    //   { label: "NO APLICA", clave: "id_rubro", value: 8 },
    //   { label: "PLASTICOS Y CAUCHO", clave: "id_rubro", value: 9 },
    //   { label: "QUIMICA", clave: "id_rubro", value: 10 },
    //   { label: "SE DESCONOCE", clave: "id_rubro", value: 11 },
    //   { label: "SERVICIOS", clave: "id_rubro", value: 12 },
    //   { label: "SE TEXTIL Y CONFECCIONES", clave: "id_rubro", value: 13 },
    //   { label: "TRANSPORTE", clave: "id_rubro", value: 14 },
    // ],
  },
};
